import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Datepicker from '@mos-cat/datepicker';

import cn from 'classnames';
import moment from 'moment/moment';
import uniqueId from 'lodash/uniqueId';

import MaskedField from '../MaskedField/MaskedField';
import TextField from '../TextField/TextField';
import Radio from '@mos-front-components/public/es/components/Radio';
import MosSelect from '@mos-front-components/public/es/components/MosSelect';

import '@mos-front-components/public/es/components/PguFormGrid/PguFormGrid.pcss';

import {
  BIRTH_REG_PLACES,
  CITIZENSHIP_VALUES as CITIZENSHIPS
} from '../../constants/citizenship';
import { EMOJI_REGEXP } from '../../constants/regexp';
import { phoneMaskOptions, snilsMaskOptions } from '../../helpers/maskOptions';

import './MainData.pcss';

import Message, {
  TYPE
} from '@mos-front-components/public/es/components/Message';

import mainDataSelector from './mainDataSelector';
import { APPLICANT_TYPES } from '../../constants/applicant';
import { DATE_FORMAT } from '../../helpers/date';

const MALE = 'm';
const FEMALE = 'f';
const MAIN_DATA = 'MAIN_DATA';

const getDisabledFields = (data, editableFields, errors) => ({
  firstNameFieldDisabled: Boolean(
    data.firstName && !editableFields.firstName && !errors.firstName
  ),
  lastNameFieldDisabled: Boolean(
    data.lastName && !editableFields.lastName && !errors.lastName
  ),
  middleNameFieldDisabled: Boolean(
    !editableFields.middleName && !errors.middleName
  ),
  birthdateFieldDisabled: Boolean(
    data.birthdate && !editableFields.birthdate && !errors.birthdate
  ),
  snilsFieldDisabled: Boolean(
    data.snils && !editableFields.snils && !errors.snils
  ),
  phoneFieldDisabled: Boolean(
    data.phone && !editableFields.phone && !errors.phone
  ),
  emailFieldDisabled: Boolean(
    data.email && !editableFields.email && !errors.email
  ),
  genderFieldDisabled: Boolean(
    data.gender && !editableFields.gender && !errors.gender
  ),
  citizenshipFieldDisabled: Boolean(
    data.citizenship && !editableFields.citizenship && !errors.citizenship
  )
});

/**
 * @this  {MainData}
 * @returns {React.PureComponent}
 * @constructor
 */
class MainData extends PureComponent {
  static getDerivedStateFromProps(nextProps) {
    const { data, errors, editableFields } = nextProps;

    return {
      data,
      errors,
      ...getDisabledFields(data, editableFields, errors)
    };
  }

  constructor(props) {
    super(props);
    const { editableFields, errors, data } = props;

    this.state = {
      data,
      errors,
      ...getDisabledFields(data, editableFields, errors)
    };
  }

  handleChange = (field, baseValue, needStrip) => {
    const { onChange } = this.props;
    const { data } = this.state;
    const newValue = baseValue.text || baseValue;
    const value =
      needStrip && typeof baseValue === 'string'
        ? baseValue.replace(EMOJI_REGEXP, '')
        : baseValue;

    if (data[field] !== value) {
      const modifiedData = { ...data, [field]: newValue };
      this.setState({ data: modifiedData });
      onChange(modifiedData, field);
    }
  };

  handleBlur = field => event => {
    this.props.onBlur(field, event);
    this.props.saveDraft();
  };

  renderFields = () => {
    const {
      withContacts,
      withSnils,
      datePickerProps: {
        maxDate = moment().format(DATE_FORMAT),
        minDate = moment()
          .subtract(130, 'years')
          .format(DATE_FORMAT)
      }
    } = this.props;
    const {
      data: { birthdate, snils, phone, email },
      errors,
      birthdateFieldDisabled,
      snilsFieldDisabled,
      phoneFieldDisabled,
      emailFieldDisabled
    } = this.state;

    if (withSnils) {
      return (
        <div>
          <div className="PguFormGrid__row">
            <div className="PguFormGrid_col PguFormGrid__col_3">
              <Datepicker
                placeholder="Дата рождения"
                onChange={({ target }) =>
                  this.handleChange('birthdate', target.value)
                }
                size="STANDARD"
                className="PguFormGrid__field"
                value={birthdate}
                error={errors.birthdate}
                disabled={birthdateFieldDisabled}
                onBlur={this.handleBlur('birthdate')}
                minDate={minDate}
                maxDate={maxDate}
              />
            </div>
            <div className="PguFormGrid_col PguFormGrid__col_3">
              <MaskedField
                label="СНИЛС"
                onChange={ev =>
                  this.handleChange('snils', ev.currentTarget.value)
                }
                maskOptions={snilsMaskOptions}
                className="PguFormGrid__field"
                value={snils}
                error={errors.snils}
                disabled={snilsFieldDisabled}
                onBlur={this.handleBlur('snils')}
              />
            </div>
          </div>
          {withContacts && (
            <div className="PguFormGrid__row">
              <div className="PguFormGrid_col PguFormGrid__col_3">
                <MaskedField
                  label="Контактный телефон"
                  maskOptions={phoneMaskOptions}
                  className="PguFormGrid__field"
                  value={phone}
                  disabled={false}
                  onChange={ev =>
                    this.handleChange('phone', ev.currentTarget.value)
                  }
                  error={errors.phone}
                  onBlur={this.handleBlur('phone')}
                  clear={() => {
                    this.handleChange('phone', '');
                  }}
                />
              </div>
              <div className="PguFormGrid_col">
                <TextField
                  label="Адрес электронной почты"
                  className="PguFormGrid__field"
                  value={email}
                  disabled={false}
                  error={errors.email}
                  maxLength={100}
                  onChange={ev =>
                    this.handleChange('email', ev.currentTarget.value, true)
                  }
                  onBlur={this.handleBlur('email')}
                  clear={() => {
                    this.handleChange('email', '');
                  }}
                />
              </div>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className="PguFormGrid__row">
        <div className="PguFormGrid_col PguFormGrid__col_3">
          <Datepicker
            placeholder="Дата рождения"
            onChange={({ target }) =>
              this.handleChange('birthdate', target.value)
            }
            size="STANDARD"
            className="PguFormGrid__field"
            value={birthdate}
            error={errors.birthdate}
            disabled={birthdateFieldDisabled}
            onBlur={this.handleBlur('birthdate')}
            minDate={minDate}
            maxDate={maxDate}
          />
        </div>
        {withContacts && (
          <React.Fragment>
            <div className="PguFormGrid_col PguFormGrid__col_3 PguFormGrid__item">
              <MaskedField
                label="Контактный телефон"
                maskOptions={phoneMaskOptions}
                className="PguFormGrid__field"
                value={phone}
                disabled={phoneFieldDisabled}
                onChange={ev =>
                  this.handleChange('phone', ev.currentTarget.value)
                }
                error={errors.phone}
                onBlur={this.handleBlur('phone')}
                clear={() => {
                  this.handleChange('phone', '');
                }}
              />
            </div>
            <div className="PguFormGrid_col PguFormGrid__col_3 PguFormGrid__item ">
              <TextField
                label="Адрес электронной почты"
                className="PguFormGrid__field"
                value={email}
                disabled={emailFieldDisabled}
                error={errors.email}
                maxLength={100}
                onChange={ev =>
                  this.handleChange('email', ev.currentTarget.value, true)
                }
                onBlur={this.handleBlur('email')}
                clear={() => {
                  this.handleChange('email', '');
                }}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  };

  static getBirthRegistrationPlaceValues = () =>
    Object.values(BIRTH_REG_PLACES.VALUES);

  static getBirthRegistrationPlaceValue = data => {
    const value = BIRTH_REG_PLACES.VALUES[data[BIRTH_REG_PLACES.NAME]];
    return value ? value.text : '';
  };

  renderBirthRegistrationPlace = () => {
    const { data, errors, saveDraft, withBirthRegistrationPlace } = this.props;

    if (!withBirthRegistrationPlace) {
      return null;
    }

    const value = MainData.getBirthRegistrationPlaceValue(data) || '';

    return (
      <div className="BirthRegistrationPlace">
        <div className="PguFormGrid__row">
          <div className="PguFormGrid_col">
            <MosSelect
              className="BirthRegistrationPlace__select"
              placeholder={BIRTH_REG_PLACES.PLACEHOLDER}
              value={value}
              suggestions={MainData.getBirthRegistrationPlaceValues()}
              hasError={errors[BIRTH_REG_PLACES.NAME]}
              dropListView
              onChange={v => {
                this.handleChange(BIRTH_REG_PLACES.NAME, v.value);
                saveDraft();
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      className,
      child,
      saveDraft,
      applicantType,
      underFourteen
    } = this.props;

    const {
      data: { lastName, firstName, middleName, gender, citizenship },
      errors,
      lastNameFieldDisabled,
      firstNameFieldDisabled,
      middleNameFieldDisabled,
      genderFieldDisabled,
      citizenshipFieldDisabled
    } = this.state;

    const blockClassName = cn('MainData', {
      [className]: className
    });
    // Для уникальности имен контролов
    const formId = uniqueId();

    const citizenshipSuggestions = CITIZENSHIPS.map(item => ({
      text: item,
      value: item
    }));

    return (
      <div className={blockClassName}>
        <div className="MainData_form">
          <div className="PguFormGrid__row">
            <div className="PguFormGrid_col PguFormGrid__col_3">
              <TextField
                label="Фамилия"
                className="PguFormGrid__field"
                value={lastName}
                error={errors.lastName}
                disabled={lastNameFieldDisabled}
                onBlur={this.handleBlur('lastName')}
              />
            </div>
            <div className="PguFormGrid_col PguFormGrid__col_3">
              <TextField
                label="Имя"
                className="PguFormGrid__field"
                value={firstName}
                error={errors.firstName}
                disabled={firstNameFieldDisabled}
                onBlur={this.handleBlur('firstName')}
              />
            </div>
            <div className="PguFormGrid_col PguFormGrid__col_3">
              <TextField
                label="Отчество"
                className="PguFormGrid__field"
                value={middleName}
                error={errors.middleName}
                disabled={middleNameFieldDisabled}
                onBlur={this.handleBlur('middleName')}
              />
            </div>
          </div>

          {this.renderFields()}

          <div className="MainData_gender">
            <div className="MainData_genderTitle">Пол:</div>
            <Radio
              className="MainData_genderField"
              label="Мужской"
              value={MALE}
              name={`gender_${formId}`}
              onChange={e => {
                this.handleChange('gender', e.target.value);
                saveDraft();
              }}
              disabled={genderFieldDisabled}
              error={errors.gender}
              checked={gender === MALE}
            />
            <Radio
              className="MainData_genderField"
              label="Женский"
              value={FEMALE}
              name={`gender_${formId}`}
              onChange={e => {
                this.handleChange('gender', e.target.value);
                saveDraft();
              }}
              error={errors.gender}
              disabled={genderFieldDisabled}
              checked={gender === FEMALE}
            />
          </div>

          {underFourteen && (
            <Message type={TYPE.ERROR}>
              <p>
                <div className="Message__Title">
                  Подача апелляции недоступна
                </div>
              </p>
              {applicantType === APPLICANT_TYPES.parent ? (
                <p>
                  Контроль на возраст не пройден. Перепроверьте правильность
                  указанных данных.
                </p>
              ) : (
                <p>
                  Вам не исполнилось 14 лет, подача апелляции на Портале не
                  доступна. Апелляция может быть подана Вашим законным
                  представителем на Портале, или Вами самостоятельно на бумажном
                  носителе в общественной приёмной регионального центра
                  обработки информации города Москвы, расположенной по адресу:
                  г. Москва, Семёновская площадь, дом 4.
                </p>
              )}
            </Message>
          )}

          {!child && !underFourteen && (
            <>
              {this.renderBirthRegistrationPlace()}
              <div className="PguFormGrid__row">
                <div className="PguFormGrid_col PguFormGrid__col_5">
                  <MosSelect
                    placeholder="Гражданство"
                    value={citizenship || ''}
                    suggestions={citizenshipSuggestions}
                    onChange={selected => {
                      this.handleChange('citizenship', selected);
                      saveDraft();
                    }}
                    disabled={citizenshipFieldDisabled}
                    hasError={errors.citizenship}
                    dropListView
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

MainData.propTypes = {
  /**
   * @param {string} className – Класс обертка
   */
  className: PropTypes.string,
  /**
   * @param {node} children – потомки
   */
  children: PropTypes.node,
  editableFields: PropTypes.shape({
    lastName: PropTypes.bool,
    firstName: PropTypes.bool,
    middleName: PropTypes.bool,
    birthdate: PropTypes.bool,
    snils: PropTypes.bool,
    phone: PropTypes.bool,
    email: PropTypes.bool,
    gender: PropTypes.bool,
    citizenship: PropTypes.bool
  }),
  errors: PropTypes.shape({
    lastName: PropTypes.string,
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    birthdate: PropTypes.string,
    snils: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    citizenship: PropTypes.string
  }),
  /**
   * @param {object} data – объект с данными
   */
  data: PropTypes.shape({
    lastName: PropTypes.string,
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    birthdate: PropTypes.string,
    snils: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.oneOf([MALE, FEMALE]),
    citizenship: PropTypes.string
  }),
  /**
   * @param {bool} withContacts – флаг указывающий на то, что форма включает в себя контактные данные
   */
  withContacts: PropTypes.bool,
  /**
   * @param {bool} withSnils – флаг указывающий на то, что форма включает в СНИЛС и отображается немного иным образом
   */
  withSnils: PropTypes.bool,
  /**
   * @param {object} data Объект со значением формы
   * @param {string} field Имя изменившегося поля
   */
  onChange: PropTypes.func,
  /**
   * @callback
   * @param {string} field Имя поля
   * @param {SynteticEvent} event Стандартный event
   */
  onBlur: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  datePickerProps: PropTypes.shape({
    minDate: PropTypes.string,
    maxDate: PropTypes.string
  }),
  isChild: PropTypes.bool,
  withBirthRegistrationPlace: PropTypes.bool
};

MainData.defaultProps = {
  className: '',
  onChange: () => {},
  children: null,
  data: {},
  errors: {},
  editableFields: {},
  withContacts: true,
  withSnils: false,
  isChild: false,
  onBlur: () => {},
  datePickerProps: {},
  withBirthRegistrationPlace: false
};

MainData.MALE = MALE;
MainData.FEMALE = FEMALE;

export { MALE, FEMALE, MAIN_DATA };

export default connect(mainDataSelector)(MainData);
